import React from 'react'
import ErrorMessage from 'utils/ErrorMessage'
import Flex from 'components/Flex'
import DeleteIcon from 'components/icons/DeleteIcon'
import { deleteFile } from 'modules/ManageProfile/actions'
import { useDispatch } from 'react-redux'
import SuccessMessage from 'utils/SuccessMessage'
import {
  StyledCardDiv,
  StyledH2,
  StyledDelete,
} from 'components/Uploader/Style'

const FileReader = ({
  fileURL,
  setFileURL,
  setErrorMessage,
  file,
  setFile,
}) => {
  const dispatch = new useDispatch()

  const handleRemove = async () => {
    let response = await dispatch(deleteFile(fileURL))
    if (response) {
      setFileURL(null)
      setFile('')
      setErrorMessage([])
      return SuccessMessage('File deleted successfully!')
    } else {
      return ErrorMessage('Failed to delete the file!')
    }
  }
  return (
    <StyledCardDiv spaceBetween center alignCenter>
      <Flex column>
        <StyledH2>{file?.name}</StyledH2>
      </Flex>
    {file &&(
      <Flex alignCenter>
        <StyledDelete onClick={() => handleRemove()}>
          <DeleteIcon />
        </StyledDelete>
      </Flex>
)}
    </StyledCardDiv>
  )
}

export default FileReader
